import { createApp } from 'vue'
import App from './App.vue'
// import BootstrapVue from "bootstrap-vue/dist/bootstrap-vue.esm";
import ElementPlus from 'element-plus';
import router from './router';
import VueHighlightJS from 'vue3-highlightjs'
import 'highlight.js/styles/solarized-light.css'


import 'element-plus/dist/index.css';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import '@/assets/css/dlab-style.css';
import '@/assets/css/dlab-style-responsive.css';

import { library } from "@fortawesome/fontawesome-svg-core";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF,faTwitter, faInstagram, faLinkedinIn, faPinterestP, faGooglePlusG } from '@fortawesome/free-brands-svg-icons'

library.add(faPhone, faFacebookF, faTwitter, faInstagram, faLinkedinIn, faPinterestP, faGooglePlusG );
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Vue.component('font-awesome-icon', FontAwesomeIcon);

createApp(App).component("font-awesome-icon", FontAwesomeIcon).use(VueHighlightJS).use(router).use(ElementPlus).mount('#app')
